<template>
  <v-layout align-start>
    <v-flex>
      <v-card class="">
        <v-app-bar color="white" elevate-on-scroll flat>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete
                outlined
                dense
                ref="sucursal"
                v-model="sucursal"
                :items="sucursalList"
                :rules="[$rules.requerido]"
                :error-messages="errorMessages"
                item-text="descripcion"
                @change="selectTalonarios()"
                item-value="id"
                label="Sucursal"
                required
              >
                <template v-slot:no-data>
                  No hay información disponible
                </template>

                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.descripcion
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action v-if="item.sin_rendir">
                    <v-badge color="error" :content="item.sin_rendir">
                      <v-icon> fa-regular fa-file-lines </v-icon>
                    </v-badge>
                  </v-list-item-action>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-autocomplete
                dense
                outlined
                ref="idTalonario"
                v-model="idTalonario"
                @change="listarRecibos('combo')"
                :items="talonarios"
                item-text="descripcion"
                item-value="id"
                label="Talonario"
                required
              >
                <template v-slot:no-data>
                  No hay información disponible
                </template>

                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.descripcion
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action v-if="item.sin_rendir">
                    <v-badge color="error" :content="item.sin_rendir">
                      <v-icon> fa-regular fa-file-lines </v-icon>
                    </v-badge>
                  </v-list-item-action>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                outlined
                dense
                class="text-xs-center"
                v-model="searchAll"
                append-icon="search"
                label="Búsqueda"
                hide-details
                @click:append="listarRecibos('search')"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="SincronizarDocumentos()"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> fa-sharp fa-solid fa-rotate </v-icon>
              </v-btn>
            </template>
            <span>Sincronizar</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                large
                @click="mostrarInactivos"
                color="primary"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>
                  {{ !inactivos ? "visibility_off" : "visibility" }}
                </v-icon>
              </v-btn>
            </template>
            <span>{{
              inactivos ? "Ocultar Aprobados" : "Mostrar Aprobados"
            }}</span>
          </v-tooltip>
        </v-app-bar>
        <v-sheet class="overflow-y-auto" :max-height="windowHeigth">
          <!-- Debug info temporal -->
          <div class="pa-2 caption grey--text">
            Estado:
            {{
              dtReciboLoad
                ? "Cargando..."
                : idTalonario
                ? "Datos cargados"
                : "Seleccione un talonario"
            }}
            | Registros: {{ dtRecibo.length }}
          </div>

          <!-- Tabla de datos -->
          <v-data-table
            v-if="!dtReciboLoad && idTalonario"
            dense
            fixed-header
            :height="windowHeigth - (isMobile ? 128 : 250)"
            :headers="headers"
            :items="dtRecibo"
            :hide-default-header="isMobile"
            mobile-breakpoint="0"
            :search="searchAll"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            loading-text="Cargando... Espere por favor"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': [20, 50, 100, 150, -1],
            }"
            :group-by="['codigoRendicion']"
            :group-desc="[false]"
            :custom-group="customGroup"
          >
            <template v-slot:[`group.header`]="{  group, headers, toggle, isOpen, items }"
            >
              <td :colspan="headers.length">
                <v-app-bar>
                  <v-btn @click="toggle" x-small icon :ref="group">
                    <v-icon v-if="isOpen">fa-solid fa-chevron-up</v-icon>
                    <v-icon v-else>fa-solid fa-chevron-down</v-icon>
                  </v-btn>

                  <viewer v-if="!$esNulo(items[0].fotoEfectivo)">
                    <img :src="items[0].fotoEfectivo" class="image" />
                  </viewer>

                  <v-icon
                    v-if="!$esNulo(items[0].fotoEfectivo)"
                    @click="
                      mostrarDialogCarga(
                        'Rendicion',
                        null,
                        items[0].idRendicion
                      )
                    "
                    :color="'info'"
                  >
                    fa-solid fa-cloud-arrow-up
                  </v-icon>

                  <v-icon
                    :class="{ parpadeo: !(items[0].bancarizacionEfectivo) }"
                    @click="
                      cuadroCargaBancarizacion(
                        items[0],'E'
                      )
                    "
                    :color="
                      items[0].bancarizacionEfectivo ? 'success' : 'warning'
                    "
                    >{{
                      items[0].bancarizacionEfectivo
                        ? "fa-sharp fa-solid fa-circle-check"
                        : "fa-brands fa-product-hunt"
                    }}</v-icon
                  >

                  <span class="mx-5 font-weight-bold">{{
                    group === "SIN RENDIR"
                      ? group
                      : group.substring(group.length - 10)
                  }}</span>
                  <v-spacer></v-spacer>
                  <span class="mx-5 font-weight-bold"
                    >{{
                      "Total Rendición:" +
                      $formatoNumero(items[0].TotalRendicion)
                    }}
                  </span>
                  <v-spacer></v-spacer>
                  <span class="mx-5 font-weight-bold">{{
                    "Total Transferencia: " +
                    $formatoNumero(items[0].totalRendicionTransferencia)
                  }}</span>
                  <v-spacer></v-spacer>
                  <span class="mx-5 font-weight-bold">{{
                    "Total Cheque: " +
                    $formatoNumero(items[0].totalRendicionCheque)
                  }}</span>
                  <v-spacer></v-spacer>
                  <span class="mx-5 font-weight-bold">{{
                    "Total Efectivo: " +
                    $formatoNumero(items[0].totalRendicionEfectivo)
                  }}</span>
                </v-app-bar>

                <div></div>
              </td>
            </template>

            <template v-slot:[`item.totalDocumento`]="{ item }">
              <div>
                {{ $formatoNumero(item.totalDocumento) }}
              </div>
            </template>
            <template v-slot:[`item.clienteDescripcion`]="{ item }">
              <div>
                {{ "(" + item.clienteCodigo + ") " + item.clienteDescripcion }}
              </div>
              <p class="font-weight-light text-subtitle-2 blue--text">
                {{ "Razón Social: " + item.razonSocial }}
              </p>
              <location-map
                :title="
                  '(' + item.clienteCodigo + ') ' + item.clienteDescripcion
                "
                :location="{ lat: item.latitud, lng: item.longitud }"
                :isMobile="isMobile"
                :height="height - 200"
              ></location-map>
            </template>

            <template v-slot:[`item.totalEfectivo`]="{ item }">
              <div>
                {{ $formatoNumero(item.totalEfectivo) }}
              </div>
            </template>
            <template v-slot:[`item.totalCheque`]="{ item }">
              <div>
                {{ $formatoNumero(item.totalCheque) }}
              </div>

              <viewer v-if="!$esNulo(item.fotoCheque)">
                <img
                  v-for="i in JSON.parse(item.fotoCheque)"
                  :key="i.foto_cheque"
                  :src="i.foto_cheque"
                  class="image"
                />
              </viewer>

              <viewer v-if="!$esNulo(item.fotoDeposito)">
                <img :src="item.fotoDeposito" class="image" />
              </viewer>
              <v-icon
                :class="{ parpadeo: !(item.bancarizacionCheque) }"
                v-if="item.fotoCheque"
                @click="
                  cuadroCargaBancarizacion(
                   item, 'CR'
                  )
                "
                :color="item.bancarizacionCheque ? 'success' : 'warning'"
                >{{
                  item.bancarizacionCheque
                    ? "fa-sharp fa-solid fa-circle-check"
                    : "fa-brands fa-product-hunt"
                }}</v-icon
              >
            </template>
            <template v-slot:[`item.totalTransferencia`]="{ item }">
              <div>
                {{ $formatoNumero(item.totalTransferencia) }}
              </div>

              <viewer>
                <img
                  v-for="i in JSON.parse(item.fotoTransferencia)"
                  :key="i.foto_transferencia"
                  :src="i.foto_transferencia"
                  class="image"
                />
              </viewer>
            </template>

            <template v-slot:[`item.numeroRecibo`]="{ item }">
              <v-btn text class="primary--text" @click="editRecibo(item)">
                {{ item.numeroRecibo }}
              </v-btn>
              <div v-if="!$esNulo(item.fotoRecibo)">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <viewer v-bind="attrs" v-on="on">
                      <img :src="item.fotoRecibo" class="image" />
                    </viewer>
                  </template>
                  <span>{{
                    $esNulo(item.fotoRecibo) ? "Cargar Imagen" : "Ver Imagen"
                  }}</span>
                </v-tooltip>
              </div>

              <div>
                {{ $formatoFechaHoras(item.fecha) }}
              </div>

              <div v-if="item.estado == 'V' || item.estado == 'F'">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="warning"
                      x-small
                      text
                      dark
                      @click="marcarPendiente(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon small>fa-regular fa-circle</v-icon>
                    </v-btn>
                  </template>
                  <span>Marcar como Rendido</span>
                </v-tooltip>
              </div>

              <v-badge
              :class="{ parpadeo: item.estado === 'R' }"
                
                color="warning"
                :value="item.estado === 'R' ? 1 : 0"
                icon="fa-solid fa-exclamation"
                overlap
              >
                <v-btn
                  text
                  :class="
                    item.estado == 'A'
                      ? 'font-weight-bold black--text'
                      : item.estado == 'C'
                      ? 'font-weight-bold primary--text'
                      : item.estado == 'P'
                      ? 'font-weight-bold primary--text'
                      : item.estado == 'B'
                      ? 'font-weight-bold error--text'
                      : item.estado == 'F'
                      ? 'font-weight-bold error--text'
                      : item.estado == 'R'
                      ? 'font-weight-bold primary--text'
                      : item.estado == 'V'
                      ? 'font-weight-bold success--text'
                      : item.estado === 'AA'
                      ? 'font-weight-bold error--text'
                      : item.estado === 'E'
                      ? 'font-weight-bold error--text'
                      : item.estado === 'I'
                      ? 'font-weight-bold black--text'
                      : item.estado === 'J'
                      ? 'font-weight-bold black--text'
                      : item.estado === 'N'
                      ? 'font-weight-bold black--text'
                      : item.estado === 'O'
                      ? 'font-weight-bold success--text'
                      : item.estado === 'PP'
                      ? 'font-weight-bold success--text'
                      : item.estado === 'RR'
                      ? 'font-weight-bold success--text'
                      : item.estado === 'U'
                      ? 'font-weight-bold black--text'
                      : 'font-weight-bold error--text'
                  "
                  @click="editRecibo(item)"
                >
                  {{
                    item.estado === "A"
                      ? "Creado"
                      : item.estado === "C"
                      ? "Respaldado"
                      : item.estado === "P"
                      ? "Por Rendir"
                      : item.estado === "B"
                      ? "Anulado"
                      : item.estado === "F"
                      ? "Rechazado"
                      : item.estado === "R"
                      ? "Rendido"
                      : item.estado === "V"
                      ? "Verificado"
                      : item.estado === "AA"
                      ? "Anulado SAC"
                      : item.estado === "E"
                      ? "Procesado con Error SAC"
                      : item.estado === "I"
                      ? "Importado SAC"
                      : item.estado === "J"
                      ? "Para aprobar SAC"
                      : item.estado === "N"
                      ? "Importando SAC"
                      : item.estado === "O"
                      ? "Aprobado NETORDER"
                      : item.estado === "PP"
                      ? "Procesado Ok SAC"
                      : item.estado === "RR"
                      ? "Registrado SAC"
                      : item.estado === "U"
                      ? "Importado en SAC"
                      : item.estado 
                  }}
                </v-btn>
              </v-badge>
            </template>

            <template v-slot:no-data>
              <div class="primary--text text-subtitle-2">
                {{
                  idTalonario
                    ? "No se encontraron registros"
                    : "Seleccione un talonario"
                }}
              </div>
            </template>
          </v-data-table>
          <!-- Skeleton loader que se muestra mientras se cargan los datos -->
          <v-skeleton-loader
            v-if="dtReciboLoad && idTalonario"
            class="pa-4"
            :height="windowHeigth - (isMobile ? 200 : 300)"
            type="table-row-divider@10"
            loading
            elevation="1"
          ></v-skeleton-loader>

          <!-- Mensaje de carga adicional -->
          <div v-if="dtReciboLoad && idTalonario" class="text-center pa-4">
            <v-progress-circular
              indeterminate
              color="primary"
              class="mb-2"
            ></v-progress-circular>
            <div class="text-subtitle-1">Cargando recibos...</div>
          </div>

          <!-- Mensaje cuando no hay talonario seleccionado -->
          <div v-if="!idTalonario && !dtReciboLoad" class="text-center pa-8">
            <v-icon size="64" color="grey lighten-1" class="mb-4">
              fa-solid fa-table-cells
            </v-icon>
            <div class="text-h6 grey--text">
              Seleccione una sucursal y talonario para ver los recibos
            </div>
          </div>
        </v-sheet>
      </v-card>

      <v-dialog v-model="dialogAlpha" persistent max-width="390">
        <v-card>
          <v-card-title>Aprobar Recibo</v-card-title>
          <v-card-text
            >¿Está seguro que desea aprobar el Recibo seleccionado?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogAlpha = false">Cancelar</v-btn>

            <div>
              <v-btn color="primary" text :loading="load" @click="aprobar()"
                >Continuar</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

     

      <v-dialog v-model="dialogGamma" persistent max-width="390">
        <v-card>
          <v-card-title>{{
            esBancarizacion
              ? "Validar Depósito"
              : "Registrar código de transacción"
          }}</v-card-title>
          <v-card-text
            >Digite el código de
            {{ esBancarizacion ? "bancarización" : "transacción" }} para aprobar
            el depósito.

            <v-text-field
              v-show="esBancarizacion && origen === 'E'"
              outlined
              color="icons"
              dense
              type="text"
              ref="codigoBancarizacion"
              v-model="reciboItem.bancarizacionEfectivo"
              :rules="esBancarizacion ? [$rules.requerido] : []"
              :error-messages="errorMessages"
              label="Código de Bancarización Efectiv"
              required
            ></v-text-field>
            <v-text-field
              v-show="esBancarizacion && !origen.includes('L') && (origen.startsWith('C') || origen.startsWith('T'))"
              outlined
              color="icons"
              dense
              type="text"
              ref="codigoBancarizacion"
              v-model="reciboItem.bancarizacionCheque"
              :rules="esBancarizacion ? [$rules.requerido] : []"
              :error-messages="errorMessages"
              label="Código de Bancarización"
              required
            ></v-text-field>
             <v-text-field
              v-show="esBancarizacion && origen.includes('L') && (origen.startsWith('C') || origen.startsWith('T'))"
              outlined
              color="icons"
              dense
              type="text"
              ref="codigoBancarizacion"
              v-model="valorDocumentoItem.bancarizacion"
              :rules="esBancarizacion ? [$rules.requerido] : []"
              :error-messages="errorMessages"
              label="Código de Bancarización"
              required
            ></v-text-field>
            <v-text-field
              v-show="!esBancarizacion"
              outlined
              color="icons"
              dense
              type="text"
              ref="codigoTransaccion"
              v-model="valorDocumentoItem.codigoTransaccion"
              :rules="!esBancarizacion ? [$rules.requerido] : []"
              :error-messages="errorMessages"
              label="Código de Transacción"
              required
            ></v-text-field>

            
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogGamma = false">Cancelar</v-btn>

            <div>
              <v-btn
                color="primary"
                v-show="reciboItem.estado !== 'RR'"
                text
                @click="validarBancarizacion()"
                >Continuar</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogLambda" persistent max-width="390">
        <v-card>
          <v-card-title>Anulación de Recibo</v-card-title>
          <v-card-text
            >Describa el motivo de anulación, para continuar.

            <v-text-field
              outlined
              color="icons"
              dense
              type="text"
              ref="motivo"
              v-model="reciboItem.observacion3"
              :rules="[$rules.requerido]"
              :error-messages="errorMessages"
              label="Motivo de Anulación"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialogLambda = false">Cancelar</v-btn>

            <div>
              <v-btn color="primary" text @click="anularRecibo()">Anular</v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogSigma"
        persistent
        :fullscreen="isMobile"
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-layout align-start v-resize="getDimensions">
          <v-flex>
            <v-card
              ref="form"
              id="lateral"
              :height="isMobile ? height : height - 100"
            >
              <v-system-bar color="white" lights-out>
                <v-spacer></v-spacer>
                <v-icon> fa-solid fa-store </v-icon>
                ({{ reciboItem.clienteCodigo }})
                {{ reciboItem.clienteDescripcion }}
              </v-system-bar>

              <v-app-bar color="white" elevate-on-scroll flat>
                <div class="headline">
                  Recibo N° {{ reciboItem.numeroRecibo }}
                </div>

                <v-spacer></v-spacer>
                <div
                  v-if="
                    reciboItem.estado == 'R' && reciboItem.bancarizacionEfectivo
                  "
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="success"
                        x-small
                        text
                        dark
                        @click="abrirDialogAprobacion()"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon>fa-solid fa-check</v-icon>
                      </v-btn>
                    </template>
                    <span>Aprobar Recibo</span>
                  </v-tooltip>
                </div>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      large
                      :disabled="
                        !(
                          reciboItem.estado === 'A' ||
                          reciboItem.estado === 'R' ||
                          reciboItem.estado === 'C'
                        )
                      "
                      @click="dialogLambda = true"
                      color="error"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark> fa-solid fa-ban </v-icon>
                    </v-btn>
                  </template>
                  <span>Anular Recibo</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      @click="closeRecibo"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                      fab
                    >
                      <v-icon dark> close </v-icon>
                    </v-btn>
                  </template>
                  <span>Cerrar</span>
                </v-tooltip>
              </v-app-bar>
              <v-alert
                v-if="reciboItem.estado === 'B'"
                text
                prominent
                type="error"
                icon="fa-solid fa-ban"
              >
                {{ reciboItem.observacion3 }}
              </v-alert>
              <v-alert
                v-if="$esNulo(reciboItem.observacion2) === false"
                text
                prominent
                type="warning"
                icon="fa-regular fa-images"
              >
                {{ reciboItem.observacion2 }}
              </v-alert>

              <v-system-bar color="white" lights-out>
                <v-icon> fa-solid fa-calendar </v-icon>
                {{ $formatoFechaHoras(reciboItem.fecha) }}
              </v-system-bar>              <v-sheet
                class="overflow-y-auto"
                :max-height="isMobile ? height - 60 : height - 60"
              >                <!-- Skeleton loaders mientras cargan los detalles -->
                <div v-if="detallesReciboLoad">
                  <v-container fluid>
                    <!-- Skeleton para imagen del recibo -->
                    <v-skeleton-loader
                      class="mb-4 mx-auto"
                      type="image"
                      height="200"
                      width="300"
                    ></v-skeleton-loader>
                    
                    <!-- Skeleton para sección de documentos -->
                    <div class="mb-4">
                      <v-skeleton-loader
                        type="heading"
                        class="mb-2"
                      ></v-skeleton-loader>
                      <v-divider class="mb-2"></v-divider>
                      <v-skeleton-loader
                        type="list-item-two-line@3"
                      ></v-skeleton-loader>
                    </div>
                    
                    <!-- Skeleton para sección de valores -->
                    <div class="mb-4">
                      <v-skeleton-loader
                        type="heading"
                        class="mb-2"
                      ></v-skeleton-loader>
                      <v-divider class="mb-2"></v-divider>
                      <v-skeleton-loader
                        type="list-item-avatar-two-line@4"
                      ></v-skeleton-loader>
                    </div>
                    
                    <!-- Indicador de carga -->
                    <div class="text-center pa-4">
                      <v-progress-circular 
                        indeterminate 
                        color="primary" 
                        size="24"
                        class="mr-2"
                      ></v-progress-circular>
                      <span class="text-subtitle-2 grey--text">Cargando detalles del recibo...</span>
                    </div>
                  </v-container>
                </div>
                
                <!-- Contenido real cuando los datos están cargados -->
                <v-container fluid v-else>
                  <div>
                    <v-tooltip
                      bottom
                      v-if="!$esNulo(reciboItem.fotoRecibo)"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <viewer v-bind="attrs" v-on="on">
                          <img :src="reciboItem.fotoRecibo" class="image-big" />
                        </viewer>
                      </template>
                      <span>{{
                        $esNulo(reciboItem.fotoRecibo)
                          ? "Cargar Imagen"
                          : "Ver Imagen"
                      }}</span>
                    </v-tooltip>
                    <v-icon
                      @click="mostrarDialogCarga('Recibo')"
                      color="info"
                      v-if="
                        reciboItem.estado === 'R' || reciboItem.estado === 'RR'
                      "
                      >{{
                        $esNulo(reciboItem.fotoRecibo)
                          ? ""
                          : ""
                      }}
                      fa-solid fa-cloud-arrow-up
                    </v-icon>
                  </div>

                  <v-list two-line>
                    <v-divider></v-divider>

                    <v-system-bar color="white">
                      <h3 class="primary--text">Documentos</h3>
                      <v-spacer></v-spacer>
                      Total
                      {{
                        reciboItem.moneda +
                        " " +
                        $formatoNumero(reciboItem.totalDocumento)
                      }}
                    </v-system-bar>

                    <v-divider></v-divider>
                    <v-list-item-group
                      v-model="selectedDocumento"
                      active-class="blue--text"
                    >
                      <template>
                        <v-list-item v-for="doc in dtDocumento" :key="doc.id">
                          <template v-slot:default="{ active }">
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold"
                                >{{ doc.codigo + " " + doc.comproTipo }}
                              </v-list-item-title>

                              <v-list-item-subtitle class="primary--text"
                                >{{ doc.sucurNombre }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle
                                >FE: {{ $formatoFechaSpanish(doc.fecha) }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle
                                :class="
                                  estaVencido(doc.venciFecha)
                                    ? 'error--text'
                                    : 'success--text'
                                "
                                >FV:
                                {{ $formatoFechaSpanish(doc.venciFecha) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-list-item-action-text
                                :class="active ? 'font-weight-bold' : ''"
                              >
                                Importe:
                                {{
                                  doc.moneda +
                                  "" +
                                  $formatoNumero(doc.importe)
                                }}
                              </v-list-item-action-text>
                              <v-list-item-action-text
                                :class="active ? 'font-weight-bold' : ''"
                              >
                                Saldo:
                                {{
                                  doc.moneda + " " + $formatoNumero(doc.saldo)
                                }}
                              </v-list-item-action-text>

                              <v-list-item-action-text>
                                Subtotal:
                                {{
                                  doc.moneda +
                                  "" +
                                  $formatoNumero(doc.subtotal)
                                }}
                              </v-list-item-action-text>
                            </v-list-item-action>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                  

                  <v-list two-line>
                    <v-divider></v-divider>
                    <v-system-bar color="white">
                      <h3 class="primary--text">Valores</h3>
                      <v-spacer></v-spacer>
                      Total
                      {{
                        reciboItem.moneda +
                        " " +
                        $formatoNumero(reciboItem.totalValor)
                      }}
                    </v-system-bar>

                    <v-divider></v-divider>
                    <v-list-item-group
                      v-model="selectedValor"
                      active-class="blue--text"
                    >
                      <template>
                        <v-list-item v-for="iValor in dtValor" :key="iValor.id">
                          <template v-slot:default="{ active }">
                            <v-list-item-avatar
                              v-if="
                                !$esNulo(iValor.fotoComprobante)"
                            >
                              <div>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <viewer v-bind="attrs" v-on="on">
                                      <img
                                        :src="iValor.fotoComprobante"
                                        class="image"
                                      />
                                    </viewer>
                                  </template>
                                  <span>{{
                                    $esNulo(iValor.fotoComprobante)
                                      ? "nada"
                                      : "Ver comprobante"
                                  }}</span>
                                </v-tooltip>
                              </div>
                            </v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title class="font-weight-bold">
                                {{ iValor.valor }}
                              </v-list-item-title>

                              <v-list-item-subtitle class="text--primary">
                                {{ $formatoFechaSpanish(iValor.fecha) }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle class="text--primary">
                                {{ iValor.banco }}
                              </v-list-item-subtitle>

                              <v-list-item-subtitle
                                class="text--primary"
                                v-if="!$esNulo(iValor.fotoDeposito)"
                              >
                                {{
                                  iValor.moneda + " " + $formatoNumero(iValor.monto)
                                }}
                              </v-list-item-subtitle>

                              <v-list-item-subtitle class="text--primary">
                                <div>
                                  <v-icon
                                    v-if="iValor.banco"
                                    :class="{ parpadeo: !(iValor.bancarizacion) }"
                                    @click="
                                      mostrarDialogCarga(
                                        'ValorDocComp',
                                        null,
                                        iValor.id,
                                        iValor.bancarizacion
                                      )
                                    "
                                    :color="
                                      iValor.bancarizacion ? 'info' : 'info'
                                    "
                                    >{{
                                      iValor.bancarizacion
                                        ? "fa-solid fa-cloud-arrow-up"
                                        : "fa-brands fa-product-hunt"
                                    }}</v-icon
                                  >
                                  <v-icon
                                    v-if="iValor.banco && iValor.valor.startsWith('Cheque')"
                                    @click="
                                      cuadroCargaBancarizacion(
                                        iValor,
                                        'CL'
                                      )
                                    "
                                    :color="
                                      iValor.bancarizacion ? 'success' : 'warning'
                                    "
                                    >{{
                                      iValor.bancarizacion
                                        ? "fa-sharp fa-solid fa-circle-check"
                                        : "fa-solid fa-triangle-exclamation"
                                    }}</v-icon
                                  >
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-icon
                                        v-if="
                                          iValor.montoSuperior &&
                                          iValor.valor.startsWith('Transferencia')
                                        "
                                        @click="
                                          cuadroCargaBancarizacion(
                                            iValor,
                                            'TL'
                                          )
                                        "
                                        :color="
                                          iValor.codigoTransaccion
                                            ? 'success'
                                            : 'warning'
                                        "
                                        v-bind="attrs"
                                        v-on="on"
                                        >{{
                                          iValor.codigoTransaccion
                                            ? "fa-sharp fa-solid fa-circle-check"
                                            : "fa-solid fa-triangle-exclamation"
                                        }}</v-icon
                                      >
                                    </template>
                                    <span>Registrar código de transacción</span>
                                  </v-tooltip>
                                </div>
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-list-item-action-text
                                v-if="$esNulo(iValor.fotoDeposito)"
                                 
                                :class="active ? 'font-weight-bold' : ''"
                              >
                                {{
                                  iValor.moneda + " " + $formatoNumero(iValor.monto)
                                }}
                              </v-list-item-action-text>
                              <v-icon
                                :class="{ parpadeo: !(iValor.bancarizacion) }"
                                v-if="iValor.codigo"
                                @click="
                                  mostrarDialogCarga(
                                    'ValorDocDep',
                                    null,
                                    iValor.id,
                                    iValor.bancarizacion
                                  )
                                "
                                :color="iValor.bancarizacion ? 'info' : 'info'"
                                >{{
                                  iValor.bancarizacion
                                    ? "fa-solid fa-cloud-arrow-up"
                                    : "fa-brands fa-product-hunt"
                                }}</v-icon
                              >
                            </v-list-item-action>
                            <v-list-item-avatar
                              v-if="!$esNulo(iValor.fotoDeposito)"
                               
                            >
                              <div>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <viewer v-bind="attrs" v-on="on">
                                      <img
                                        :src="iValor.fotoDeposito"
                                        class="image"
                                      />
                                    </viewer>
                                  </template>
                                  <span>{{
                                    $esNulo(iValor.fotoDeposito) 
                                      ? "nada"
                                      : "Ver depósito dell valor"
                                  }}</span>
                                </v-tooltip>
                              </div>
                            </v-list-item-avatar>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>

                  <v-divider></v-divider>
                  <v-system-bar color="white">
                    <h3 class="primary--text">Ajuste</h3>
                    <v-spacer></v-spacer>
                    Total
                    {{
                      reciboItem.moneda +
                      " " +
                      $formatoNumero(reciboItem.totalAjuste)
                    }}
                  </v-system-bar>                  <v-divider></v-divider>
                </v-container> <!-- Fin del contenido real -->
              </v-sheet>
            </v-card>
          </v-flex>
        </v-layout>
      </v-dialog>

      <v-dialog dense v-model="dialogKappa" persistent max-width="500px">
        <v-card>
          <v-app-bar color="white" elevate-on-scroll flat>
            <v-card-title>
              <span class="headline">Carga de Foto</span>
            </v-card-title>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  @click="dialogKappa = false"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> close </v-icon>
                </v-btn>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
          </v-app-bar>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-file-input
                    dense
                    id="fileValor"
                    ref="fileValor"
                    v-model="fileValor"
                    @change="archivoCambiadoImagen"
                    counter
                    :rules="[$rules.requeridoArchivo]"
                    show-size
                    chips
                    accept="image/*"
                    prepend-icon="camera_alt"
                    placeholder="Seleccione una imagen"
                  >
                    <template v-slot:selection="{ text }">
                      <v-chip color="primary">
                        {{ text }}
                      </v-chip>
                    </template>
                  </v-file-input>
                  <v-text-field
                    outlined
                    color="icons"
                    dense
                    type="text"
                    ref="detalleFoto"
                    v-model="detalleFoto"
                    :rules="[$rules.requerido]"
                    :error-messages="errorMessages"
                    label="Motivo de Cambio"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click.prevent="
                    tipoCarga === 'Recibo'
                      ? saveRecibo()
                      : tipoCarga === 'Rendicion'
                      ? saveRendicion()
                      : tipoCarga === 'ValorDocComp'
                      ? saveValorDocComprobante()
                      : tipoCarga === 'ValorDocDep'
                      ? saveValorDocDeposito()
                      : saveValorDocDeposito()
                  "
                  color="success"
                  :loading="loadRecibo"
                  v-bind="attrs"
                  v-on="on"
                  fab
                >
                  <v-icon dark> done </v-icon>
                </v-btn>
              </template>
              <span>Cargar Imagen</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import dialogMixin from "../plugins/dialogs.js";
import LocationMap from "@/components/Mapas/LocationMap.vue";

export default {
  mixins: [dialogMixin],
  components: {
    LocationMap,
  },
  data() {
    return {
      // Declaración de variables globales
      usuario: this.$store.state.usuario.user,
      // Declaración de arrays
      dtRecibo: [],
      dtReciboLoad: false, // Inicializar como false hasta que se seleccione un talonario
      isComponentReady: false, // Flag para evitar cargas durante inicialización
      lastOptionsChangeTimeout: null, // Para debounce de cambios de options
      areaList: [],
      subareaList: [],
      talonarios: [],
      reciboItem: {},
      documentoItem: {},
      valorDocumentoItem: {},      // Declaración de variables de Dialog
     
      dialogAlpha: false,
      dialogGamma: false,
      dialogSigma: false,
      detallesReciboLoad: false, // Variable para controlar skeleton loader en dialogSigma
      // Declaración de variables de formulario
      id: "",
      codigo: "",
      descripcion: "",
      idTalonario: "",
      codigoBancarizacion: "",
      estado: "",
      origen: "",
      idRendicion: 0,
      idValDoc: 0,
      file: null,
      load: false,
      icono: "",
      color: "",
      sucursal: "",
      // Variables comentadas - ahora usar reciboItem
      // fotoRecibo: "",
      // estado_recibo: "",
      // bancarizacionCheque: false,
      // bancarizacionEfectivo: false,
      // moneda: "",
      // totalDocumento: "",
      // total_valor: "",
      // TotalAjuste: "",
      // detalleFoto_recibo: "",
      // motivo: "",
      detalleFoto: "",
      tipoCarga: "",
      fileValor: null,
      esBancarizacion: false, //determina cuando una factura o pago corresponden a montos iguales o superiores a 50000 Bs.
      selectedDocumento: [],
      selectedRendicion: [],
      selectedValor: [],
      dtDocumento: [],
      dtRendicion: [],
      dtEfectivo: [],
      dtCheque: [],
      dtTransferencia: [],
      dtValor: [],
      sucursalList: [],
      // Declaración de variables de tabla
      selected: [2],
      headers: [
        {
          text: "Rendicion",
          value: "codigoRendicion",
          align: "left",
          groupable: false,
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Recibo",
          value: "numeroRecibo",
          align: "center",
          groupable: false,
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Fecha ",
          value: "fecha",
          align: "left",
          groupable: false,
          align: " d-none",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Cliente",
          value: "clienteDescripcion",
          align: "left",
          groupable: false,
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Total Documento",
          value: "totalDocumento",
          align: "right",
          groupable: false,
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Total Transferencia",
          value: "totalTransferencia",
          align: "right",
          groupable: false,
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Total Cheque",
          value: "totalCheque",
          align: "right",
          groupable: false,
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Total Efectivo",
          value: "totalEfectivo",
          align: "right",
          groupable: false,
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Total Ajuste",
          value: "totalAjuste",
          align: "right",
          groupable: false,
          class: "primary font-weight-black white--text text-subtitle-2",
        },
      ],
      searchAll: this.$route.query.numero,
      esEditado: false,
      editarCodigo: false,
      editedIndexCco: false,
      inactivos: false,
      mostrarErrores: false,
      // variables de errores
      valida: 0,
      errorMessages: "",
      loadRecibo: false,
      error: "",
      // variables de tamaño de pantalla
      isMobile: false,
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight,
      options: {
        page: 1,
        itemsPerPage: 20,
        sortBy: ["CodigoRendicion"], // Ajustar para que sea un array
        sortDesc: [false], // Ajustar para que sea un array
      },
      valorDocumentoObject: {},
      totalItems: 0,
    };
  },

  computed: {
    formTitle() {
      return !this.esEditado ? "Nuevo Registro" : "Actualizar Registro";
    },

    form() {
      return {
        descripcion: this.descripcion,
      };
    },
    formBancarizacion() {
      return {
        codigoBancarizacion: this.codigoBancarizacion,
      };
    },
    formSubirArchivo() {
      return {
        detalleFoto: this.detalleFoto,
      };
    },
  },

  watch: {
   
    name() {
      this.errorMessages = "";
    }, // Watcher optimizado para options - solo recarga cuando es necesario
    options: {
      handler(newOptions, oldOptions) {
        // Solo recargar si el componente está listo y hay talonario seleccionado
        if (!this.isComponentReady || !this.idTalonario) return;

        // Si es la primera vez (oldOptions es undefined), no recargar
        if (!oldOptions) return;

        // Solo recargar si cambió la página, items por página, o el ordenamiento
        const shouldReload =
          newOptions.page !== oldOptions.page ||
          newOptions.itemsPerPage !== oldOptions.itemsPerPage ||
          JSON.stringify(newOptions.sortBy) !==
            JSON.stringify(oldOptions.sortBy) ||
          JSON.stringify(newOptions.sortDesc) !==
            JSON.stringify(oldOptions.sortDesc);
        if (shouldReload) {
          console.log("Options changed, reloading data:", {
            page: newOptions.page !== oldOptions.page,
            itemsPerPage: newOptions.itemsPerPage !== oldOptions.itemsPerPage,
            sortBy:
              JSON.stringify(newOptions.sortBy) !==
              JSON.stringify(oldOptions.sortBy),
            sortDesc:
              JSON.stringify(newOptions.sortDesc) !==
              JSON.stringify(oldOptions.sortDesc),
          });

          // Limpiar timeout anterior si existe
          if (this.lastOptionsChangeTimeout) {
            clearTimeout(this.lastOptionsChangeTimeout);
          }

          // Establecer nuevo timeout para debounce
          this.lastOptionsChangeTimeout = setTimeout(() => {
            console.log("Debounced load triggered for options-changed");
            this.listarRecibos("options-changed");
          }, 300);
        }
      },
      deep: true,
    },
  },
  mounted() {
    window.addEventListener("resize", this.getDimensions);
    // Activar la flag después de que el componente esté montado
    this.$nextTick(() => {
      this.isComponentReady = true;
    });
  },
  unmounted() {
    window.removeEventListener("resize", this.getDimensions);
  },

  created() {
    //this.$gtag.pageview('/areaDelPresupuestoPrueba')
    this.$store.dispatch("actualizarTitulo", "Aprobación de Recibos");
    this.selectSucursal();

    //this.selectTalonarios();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
    // Limpiar timeout si existe
    if (this.lastOptionsChangeTimeout) {
      clearTimeout(this.lastOptionsChangeTimeout);
    }
  },
  methods: {
    archivoCambiado(e) {
      this.selectedFile = e;
    },

    getDimensions() {
      this.width = document.documentElement.clientWidth;
      this.height = document.documentElement.clientHeight;
      this.isMobile = this.width < 768;
    },
    selectSucursal() {
      let me = this;
      me.dtUsuariosLoad = true;
      axios
        .get("api/clientes/SelectSucursal")
        .then(function (response) {
          me.sucursalList = response.data;
        })
        .catch(function (error) {
          me.dtUsuariosLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    listar(origen) {
      let me = this;
      console.log("listar called with origen:", origen);
      console.log("dtReciboLoad before:", me.dtReciboLoad);

      if (!me.idTalonario) {
        console.log("No idTalonario in listar, returning");
        return;
      }

      if (origen === "combo") {
        me.options.page = 1;
        me.searchAll = "";
      }

      me.dtReciboLoad = true;
      console.log("dtReciboLoad set to true in listar");
      const { page, itemsPerPage, sortBy, sortDesc } = me.options;

      axios
        .get("api/recibos/ListarPorTalonario", {
          params: {
            talonario: me.idTalonario,
            page,
            itemsPerPage,
            sortBy: sortBy[0],
            sortDesc: sortDesc[0],
            palabraClave: me.searchAll,
          },
        })
        .then(function (response) {
          console.log(
            "Response received in listar, dtReciboLoad:",
            me.dtReciboLoad
          );
          const { items, totalItems } = response.data;
          me.dtRecibo = items;
          me.totalItems = totalItems;
          me.dtReciboLoad = false;
          console.log(
            "dtReciboLoad set to false in listar, items loaded:",
            items.length
          );
        })
        .catch(function (error) {
          console.log(
            "Error occurred in listar, setting dtReciboLoad to false"
          );
          me.dtReciboLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    listarRecibos(origen) {
      let me = this;
     
      if (!me.idTalonario) {
        console.log("No idTalonario, returning");
        return;
      }

      if (origen === "combo") {
        me.options.page = 1;
        me.searchAll = "";
      }

      me.dtReciboLoad = true;
      me.dtRecibo = [];
      
      const { page, itemsPerPage, sortBy, sortDesc } = me.options;
      

      axios
        .get("api/recibos/ListarPorTalonarioOptimizado", {
         params: {
            talonario: me.idTalonario,
            page,
            itemsPerPage,
            sortBy: sortBy[0],
            sortDesc: sortDesc[0],
            palabraClave: me.searchAll,
          },
        })
        .then((response) => {
          console.log("Response received, dtReciboLoad:", me.dtReciboLoad);
          console.log("Response data:", response.data);
          const { items, totalItems } = response.data;

          // Cada item ya tiene .valores y .documentos directamente
          me.dtRecibo = items;
          me.totalItems = totalItems;
          me.dtReciboLoad = false;
          console.log("dtReciboLoad set to false, items loaded:", items.length);
        })
        .catch((error) => {
          console.log("Error occurred, setting dtReciboLoad to false");
          me.dtReciboLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    mostrarInactivos() {
      this.inactivos = !this.inactivos;
      this.listarRecibos("mostrarInactivos");
    },

    abrirDialogAprobacion() {
      const tieneError = this.dtValor.some((element) => {
        if (
          element.montoSuperior &&
          element.valor.includes("Transferencia") &&
          element.codigoTransaccion === null
        ) {
          this.$store.dispatch("setSnackbar", {
            text: "No se puede aprobar el recibo, debe registrar el número de transacción de la transferencia.",
            color: "error",
          });

          return true;
        }
        return false;
      });

      if (tieneError) return; // Detiene la ejecución si hay error
      this.id = this.reciboItem.id;
      this.dialogAlpha = true;
      this.estado = this.reciboItem.estado;
    },


    archivoCambiado(e) {
      this.selectedFile = e;
    },

    mostrarCarga() {
      this.dialogCargaExcel = true;
    },

 

    limpiarCargaExcel() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },
    cuadroCargaBancarizacion(item,origen) {
      this.esBancarizacion = true;
      this.dialogGamma = true;
      this.origen = origen;
      if (origen === "CL" || origen === "TL") {
        this.valorDocumentoItem = item;
        this.esBancarizacion = item.valor.montoSuperior;
        this.origen = item.valor.startsWith("Transferencia") ? "TL" : "CL";
      } else {
        this.reciboItem = item;

      }
      
    },
    /*cuadroCargaBancarizacionCheque(item) {
      this.esBancarizacion = true;
      this.dialogGamma = true;
      this.origen = "C";
      this.valorDocumentoItem = item;
      this.reciboItem = item;
    },
    cuadroCargaBancarizacionTransferencia(idValdDoc, bancarizacion) {
      this.esBancarizacion = false;
      this.dialogGamma = true;
      this.origen = "T";
      this.idValDoc = idValdDoc;
      this.codigoTransaccion = bancarizacion;
    },*/    
    editRecibo(item) {
      console.log("editRecibo called with item:", item);
      this.reciboItem = item;
      
      this.dialogSigma = true; // Abrir el diálogo inmediatamente
      this.dtValor = item.valores || [];
      this.dtDocumento = item.documentos || [];
      // Variables refactorizadas - ahora usar reciboItem directamente
      // this.TotalAjuste = item.TotalAjuste;
      // this.totalDocumento = item.totalDocumento;
      // this.total_valor = item.total_valor;
      // this.fotoRecibo = item.fotoRecibo;
      // this.estado_recibo = item.estado;
      // this.motivo = item.observacion3;
      // this.detalleFoto_recibo = item.observacion2;
      // this.moneda = item.moneda;
      // this.bancarizacionEfectivo = item.bancarizacionEfectivo;
      // this.bancarizacionCheque = item.bancarizacionCheque;
    },

    customGroup(items, groupBy) {
      if (!groupBy.length) return items;

      const grouped = items.reduce((acc, item) => {
        const groupKey = groupBy.map((by) => item[by]).join("_");
        if (!acc[groupKey]) {
          acc[groupKey] = {
            name: groupKey,
            items: [],
          };
        }
        acc[groupKey].items.push(item);
        return acc;
      }, {});

      return Object.values(grouped);
    },

    obtenerValorDocumentoDetalle(idRec) {
      let me = this;

      axios
        .get("api/valor_documentos/ListarPorRecibo/" + idRec)
        .then(function (response) {
          me.dtValor = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },    obtenerDetallesRecibo(idRec) {
      let me = this;

      axios
        .get("api/recibos/DetallesRecibo/" + idRec)
        .then(function (response) {
          console.log("Detalles recibo response:", response.data);
          const recibo = response.data;
          me.dtValor = recibo.valores || [];
          me.dtDocumento = recibo.documentos || [];
          me.detallesReciboLoad = false; // Desactivar skeleton loader
        })
        .catch(function (error) {
          me.detallesReciboLoad = false; // Desactivar skeleton loader en caso de error
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    cleanRecibo() {
      this.selectedFile = null;
      this.fileValor = null;
      this.file;

      this.detalleFoto = "";
    },    closeRecibo() {
      this.dialogSigma = false;
      this.detallesReciboLoad = false; // Resetear estado de carga
      this.cleanRecibo();
    },
    estaVencido(fecha) {
      var fechaActual = new Date();
      var fechaVencimiento = new Date(fecha);
      if (fechaActual > fechaVencimiento) {
        return true;
      } else {
        return false;
      }
    },

    mostrarDialogCarga(tipo, item, id) {
      if (item != undefined) {
        this.idCheque = item.id_valor_documento;
      }
      if (id != undefined && tipo === "Rendicion") {
        this.idRendicion = id;
      }
      if (
        id != undefined &&
        (tipo === "ValorDocComp" || tipo === "ValorDocDep")
      ) {
        this.idValDoc = id;
      }

      this.tipoCarga = tipo;
      this.dialogKappa = true;
    },

    saveRecibo() {
      let me = this;
      if (this.validarGenerico(me.formSubirArchivo) > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe ingresar el motivo de cambio de foto.",
          color: "error",
        });
        return;
      }

      const formData = new FormData();
      formData.append("id", this.reciboItem.id);
      formData.append("usuario", this.usuario);
      formData.append("detalle", this.detalleFoto);
      if (this.selectedFile != null) {
        formData.append("subido", this.selectedFile);
      } else {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo.",
          color: "error",
        });
        return;
      }
      me.loadRecibo = true;
      axios
        .put("api/recibos/ReSubirImagen", formData)
        .then(function (response) {
          me.loadRecibo = false;
          me.fotoRecibo = response.data;
          me.closeRecibo();
          me.listarRecibos("saveRecibo");
          me.$store.dispatch("setSnackbar", {
            text: "Imagen cargada exitosamente. ",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    saveRendicion() {
      let me = this;
      if (this.validarGenerico(me.formSubirArchivo) > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe ingresar el motivo de cambio de foto.",
          color: "error",
        });
        return;
      }

      const formData = new FormData();
      formData.append("id", this.idRendicion);
      formData.append("usuario", this.usuario);
      formData.append("detalle", this.detalleFoto);
      if (this.selectedFile != null) {
        formData.append("subido", this.selectedFile);
      } else {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo.",
          color: "error",
        });
        return;
      }
      me.loadRecibo = true;
      axios
        .put("api/rendiciones/ReSubirImagen", formData)
        .then(function (response) {
          me.loadRecibo = false;
          me.dialogKappa = false;
          me.closeRecibo();

          me.listarRecibos("saveRendicion");
          me.$store.dispatch("setSnackbar", {
            text: "Imagen cargada exitosamente. ",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    saveValorDocComprobante() {
      let me = this;
      if (this.validarGenerico(me.formSubirArchivo) > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe ingresar el motivo de cambio de foto.",
          color: "error",
        });
        return;
      }

      const formData = new FormData();
      formData.append("id", this.idValDoc);
      formData.append("usuario", this.usuario);
      formData.append("detalle", this.detalleFoto);
      if (this.selectedFile != null) {
        formData.append("subido", this.selectedFile);
      } else {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo.",
          color: "error",
        });
        return;
      }
      me.loadRecibo = true;
      axios
        .put("api/valor_documentos/ReSubirImagenComprobante", formData)
        .then(function (response) {
          me.loadRecibo = false;
          me.dialogKappa = false;
          me.closeRecibo();

          me.$store.dispatch("setSnackbar", {
            text: "Imagen cargada exitosamente. ",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    saveValorDocDeposito() {
      let me = this;
      if (this.validarGenerico(me.formSubirArchivo) > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Debe ingresar el motivo de cambio de foto.",
          color: "error",
        });
        return;
      }

      const formData = new FormData();
      formData.append("id", this.idValDoc);
      formData.append("usuario", this.usuario);
      formData.append("detalle", this.detalleFoto);
      if (this.selectedFile != null) {
        formData.append("subido", this.selectedFile);
      } else {
        this.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo.",
          color: "error",
        });
        return;
      }
      me.loadRecibo = true;
      axios
        .put("api/valor_documentos/ReSubirImagenDeposito", formData)
        .then(function (response) {
          me.loadRecibo = false;
          me.dialogKappa = false;
          me.closeRecibo();

          me.$store.dispatch("setSnackbar", {
            text: "Imagen cargada exitosamente. ",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    anularRecibo() {
      let me = this;
      let encodedMotivo = encodeURIComponent(
        me.reciboItem.observacion3 || "Anulación por parte del administrador"
      );
      axios
        .put(
          "api/recibos/AnularAdmin/" +
            me.reciboItem.id +
            "/" +
            encodedMotivo +
            "/" +
            me.usuario,
          {}
        )
        .then(function (response) {
          me.closeRecibo();
          me.reciboItem.estado = "B";
          me.reciboItem.observacion3 = response.data;
          //me.listarRecibos("anularRecibo");
          me.$store.dispatch("setSnackbar", {
            text: "Recibo anulado exitosamente" + response.data,
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    archivoCambiadoImagen(e) {
      this.selectedFile = e;
      if (e != null) {
        this.foto = URL.createObjectURL(this.selectedFile);
      } else {
        this.foto = "/uploads/student.png";
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },
    validarGenerico(obj) {
      this.valida = 0;

      Object.keys(obj).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    validarBancarizacion() {
      let me = this;

      

      var url = "";
      var idRec = 0;
      console.log("Recibo Item:", me.reciboItem);
      console.log("Origen:", me.origen);
      if (this.origen === "E") {
        if (me.reciboItem.bancarizacionEfectivo === null) {
          me.$store.dispatch("setSnackbar", {
            text: "Debe ingresar el número de bancarización.",
            color: "error",
          });
          return;
        }
        url =
          "api/rendiciones/registrarDeposito/" +
          me.reciboItem.idRendicion +
          "/" +
          me.reciboItem.bancarizacionEfectivo +
          "/" +
          me.usuario;
        idRec = 1;
      }
      if (this.origen === "CR") {
        url =
          "api/valor_documentos/aprobar/" +
          me.reciboItem.idValorDoc +
          "/" +
          me.reciboItem.bancarizacionCheque +
          "/" +
          me.usuario;
        idRec = me.reciboItem.id;
      }
      if (this.origen === "CL") {
        url =
          "api/valor_documentos/aprobar/" +
          me.valorDocumentoItem.id +
          "/" +
          me.valorDocumentoItem.bancarizacion +
          "/" +
          me.usuario;
        idRec = me.reciboItem.id;
      }
      if (this.origen.startsWith("T")) {
        url =
          "api/valor_documentos/codigoTransaccion/" +
          me.valorDocumentoItem.id +
          "/" +
          me.valorDocumentoItem.codigoTransaccion +
          "/" +
          me.usuario;
        idRec = me.reciboItem.id;
      }

      axios
        .put(url, {})
        .then(function (response) {
          console.log("Bancarización response:",url, response.data);
          if (me.origen === "E") {
            //me.reciboItem.bancarizacionEfectivo = response.data;
            me.dtRecibo.forEach((item) => {
              if (item.codigoRendicion === me.reciboItem.codigoRendicion) {
                item.bancarizacionEfectivo = response.data;
              }
            });
          } 
          else if (me.origen.startsWith("C")) {
            me.valorDocumentoItem.bancarizacion = response.data;
            me.reciboItem.bancarizacionCheque = response.data;
            me.dtRecibo.forEach((item) => {
              if (item.id === me.reciboItem.id) {
                item.valores.forEach((valor) => {
                  valor.bancarizacion = response.data;
                });
              }
            });
          } else if (me.origen === "T") {
            me.reciboItem.codigoTransaccion = response.data;
          }
         
          //me.listarRecibos("validarBancarizacion");
          //me.obtenerValorDocumentoDetalle(idRec);
          me.dialogGamma = false;
          me.codigo;
          me.$store.dispatch("setSnackbar", {
            text: "Depósito validado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    aprobar() {
      let me = this;
      me.load = true;
      axios
        .put("api/recibos/aprobar/" + me.id + "/" + me.usuario, {})
        .then(function (response) {
         
          me.reciboItem.estado = response.data;
          me.$store.dispatch("setSnackbar", {
            text: "Recibo aprobado exitosamente.",
            color: "success",
          });
          me.exportarSAC();
          me.closeRecibo();
        })
        .catch(function (error) {
          console.error(error);
          me.load = false;
        });
    },

    exportarSAC() {
      let me = this;
      
      axios
        .put("api/recibos/ExportarSAC/" + me.reciboItem.id, {})
        .then(function (response) {
         
          me.$store.dispatch("setSnackbar", {
            text: "Datos enviados a SAC ",
            color: "success",
          });
          //me.SincronizarRecibos();
          reciboItem.estado = response.data;
          me.load = false;
          me.dialogAlpha = false;
        })
        .catch(function (error) {
         // me.SincronizarRecibos();
          me.load = false;
          me.dialogAlpha = false;
          me.$store.dispatch("setSnackbar", {
            text: "Datos enviados a SAC ",
            color: "success",
          });
        });
    },

    SincronizarRecibos() {
      let me = this;

      axios
        .put("api/recibos/SincronizarRecibos", {})
        .then(function (response) {
          me.listarRecibos("SincronizarRecibos");

          me.$store.dispatch("setSnackbar", {
            text: "Recibos Sincronizados con SAC exitosamente. ",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },
    SincronizarDocumentos() {
      let me = this;

      axios
        .put("api/recibos/SincronizarDocumentos", {})
        .then(function (response) {
          me.SincronizarRecibos();
          me.$store.dispatch("setSnackbar", {
            text: "Documentos sincronizados con SAC exitosamente. ",
            color: "success",
          });
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text: error.response.data,
            color: "error",
          });
        });
    },

    selectTalonarios() {
      let me = this;
      me.dtRecibo = [];
      axios
        .get("api/talonarios/SelectAprobacion/" + me.sucursal)
        .then(function (response) {
          me.talonarios = response.data;
        })
        .catch(function (error) {
          console.error(error);
        });
    },


    marcarPendiente(item) {
      let me = this;
      axios
        .put("api/recibos/rendido/" + item.id + "/" + me.usuario, {})
        .then(function (response) {
          me.listarRecibos("marcarPendiente");

          me.$store.dispatch("setSnackbar", {
            text: "Transferencia marcada como pendiente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.error(error);
        });
    },

    download(link, title) {
      var element = document.createElement("a");
      element.setAttribute("href", link);
      element.setAttribute("download", title);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
  },
};
</script>
<style>
.image {
  width: 20px;
  /* Ajustar el tamaño de la imagen */
  height: 20px;
  /* Ajustar el tamaño de la imagen */
  border-radius: 50%;
  /* Hacer la imagen redonda */
  margin-right: 5px;
}

.image-big {
  object-fit: fill;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  border: solid 1px #ccc;
}
/* definimos un estilo para que el icono de badge parpadee */
.badge {
  position: relative;
  display: inline-block;
}

.parpadeo {
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

</style>
